<!-- This file is not localized on purpose as it's a DE-only integration -->

<rt-dialog-header [heading]="'rti.gfea.name' | translate">
  <div
    [innerHTML]="
      'rti.gfea.create_posting.modal.subtitle'
        | translate: { helpArticleUrl: GFEA_HELP_ARTICLE_URL }
    "
  ></div>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  @if (postingForm) {
    <rti-gfea-posting-form
      [form]="postingForm"
      [offer]="dialogData.offer"
      [selectableOffers]="suggestedOffers"
    ></rti-gfea-posting-form>
  }
  <rti-error-messages-wrapper [errors]="errors"> </rti-error-messages-wrapper>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button variant="primary" [disabled]="!formValid" [loading]="creating" (click)="publish()">
    {{ 'rti.common.submit' | translate }}
  </rt-button>
</rt-dialog-footer>
